/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSelector } from "@reduxjs/toolkit";
import { selectHasCurrentModel } from "../model/model.selectors";

/**
 * @typedef {import("./webpage.state")["webpageState"]} WebpageState
 */

/**
 * @typedef {object} RootState
 * @property {WebpageState} webpage
 */

/**
 * @param {RootState} state
 */
export function selectCurrentWebpage (state) {
    return state.webpage.current;
}

/**
 * @param {RootState} state
 */
export function selectUpdateSettingsCount (state) {
    return state.webpage.settingsUpdateCount;
}
/**
 * @param {RootState} state
 */
export function selectHasModelReference (state) {
    const webpage = state.webpage.current;
    return !!webpage?.model;
}

export const selectHasMissingModel = createSelector(
    selectHasModelReference,
    selectHasCurrentModel,
    (hasModelReference, hasCurrentModel) => {
        return !hasModelReference || !hasCurrentModel;
    }
);

/**
 * @param {RootState} state
 */
export function selectWebpageLoading (state) {
    return state.webpage.loading;
}

/**
 * @param {RootState} state
 */
export function selectReloadRequired (state) {
    return state.webpage.reloadRequired;
}

/**
 * @param {RootState} state
 */
export function selectWebpageStatuses (state) {
    const { changeNeeded, holdNav, saveDisabled } = state.webpage;

    return {
        changeNeeded,
        holdNav,
        saveDisabled,
    };
}

/**
 * @param {RootState} state
 */
export function selectPublishStatus (state) {
    return state.webpage.publishStatus;
}

/**
 * @param {RootState} state
 */
export function selectPublishChange (state) {
    return state.webpage.publishStatus.publishChange;
}

/**
 * @param {RootState} state
 */
export function selectPublishStatusLoading (state) {
    return state.webpage.publishStatusLoading;
}
